import {Button, Icon, Table} from "semantic-ui-react";
import React from "react";

export function OperatingCostList(props) {
    const operatingCosts = props.operatingCosts;

    const listOperatingCosts = operatingCosts.map((operatingCost) =>
        <Table.Row key={operatingCost.id}>
            <Table.Cell>{operatingCost.id}</Table.Cell>
            <Table.Cell>{operatingCost.date}</Table.Cell>
            <Table.Cell>{operatingCost.total}</Table.Cell>
            <Table.Cell>{operatingCost.note}</Table.Cell>
            <Table.Cell><Button icon><Icon name='delete'
                                           onClick={() => props.remove(operatingCost.id)}/></Button></Table.Cell>
        </Table.Row>
    );

    return (
        <Table celled striped>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>ID</Table.HeaderCell>
                    <Table.HeaderCell>Date</Table.HeaderCell>
                    <Table.HeaderCell>Total</Table.HeaderCell>
                    <Table.HeaderCell>Note</Table.HeaderCell>
                    <Table.HeaderCell></Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>{listOperatingCosts}</Table.Body>
        </Table>
    )
}